<template>
    <div class="details" :class="setColor">
        <div class="item">{{ index }}</div>
        <div class="item"><b-input v-model="item.red_fecha" size="is-small"></b-input></div>
        <div class="item"><b-input v-model="item.red_dni_ruc" size="is-small"></b-input></div>
        <div class="item"><b-input v-model="item.red_razon_social" size="is-small"></b-input></div>
        <div class="item"><b-input v-model="item.red_descripcion" size="is-small"></b-input></div>
        <div class="item">
            <b-autocomplete icon="magnify" clearable size="is-small" :open-on-focus="true" field="cec_codigo" :data="centros_costo_filtered" v-model="cec_codigo_text" :append-to-body="true" @input="setCentroCosto">
                <template slot-scope="props">
                    <div :title="props.option.cec_descripcion">{{ props.option.cec_codigo }}</div>
                </template>
            </b-autocomplete>
        </div>
        <div class="item">
            <b-autocomplete icon="magnify" clearable size="is-small" :open-on-focus="true" field="tid_descripcion" append-to-body="true" :data="tipos_documento_filtered" v-model="tid_descripcion_text" @input="setTipoDocumento">
                <template slot-scope="props">{{ props.option.tid_descripcion }}</template>
            </b-autocomplete>
        </div>
        <div class="item"><b-input v-model="item.red_serie" size="is-small"></b-input></div>
        <div class="item"><b-input v-model="item.red_numero" size="is-small"></b-input></div>
        <div class="item flex"><b-input v-model="item.red_importe" size="is-small"></b-input></div>
        <div class="item">
            <a href="#" @click.prevent="retirar(item.id)" title="retirar"><span class="icon has-text-danger"><i class="mdi mdi-delete mdi-18px"></i> </span></a>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "RendicionItem",
    props: {
        caj_id: {
            type: Number,
            default: 0
        },
        item: {
            type: Object
        },
        index: {
            type: Number
        },
        centros_costo: {
            type: Array,
            default: []
        },
        tipos_documento: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            cec_codigo_text: "",
            tid_descripcion_text: "",
        }
    },
    computed: {
        centros_costo_filtered() {
            return this.centros_costo.filter((item) => {
                if (item.cec_codigo && this.cec_codigo_text) {
                    let text1 = item.cec_codigo.replace(/[\s.]/g, "").toLowerCase()
                    let text2 = this.cec_codigo_text.replace(/[\s.]/g, "").toLowerCase()
                    return text1.indexOf(text2) >= 0
                } else {
                    return true
                }
            })
        },
        tipos_documento_filtered() {
            return this.tipos_documento.filter((item) => {
                if (item.tid_descripcion && this.tid_descripcion_text) {
                    let text1 = item.tid_descripcion.toLowerCase().replace(/\s/g, "")
                    let text2 = this.tid_descripcion_text.toLowerCase().replace(/\s/g, "")
                    return text1.indexOf(text2) >= 0
                } else {
                    return true
                }
            })
        },
        setColor() {
            return this.item.cec_flag || this.item.tid_flag ? "error" : "normal"
        }
    },
    methods: {
        ...mapActions("CajaStore", ["_retirarDocumento"]),
        setCentroCosto(cec_codigo) {
            this.item.cec_codigo = cec_codigo
        },
        setTipoDocumento(tid_descripcion) {
            this.item.tid_descripcion = tid_descripcion
        },
        retirar(id) {
            this.$emit("retirar", id)
        },
    },
    mounted() {
        if (this.item) {
            this.cec_codigo_text = this.item.cec_codigo
            this.tid_descripcion_text = this.item.tid_descripcion
        }
    },
}
</script>
<style scoped>
.details {
    display: grid;
    grid-template-columns: 40px 100px 120px repeat(2, 1fr) 200px 200px 100px 100px 100px 40px;
    align-items: center;
    border-bottom: 1px solid #ccc;
}

.details>.item {
    padding: 6px;
}

.normal {
    background-color: unset;
}

.error {
    background-color: #ea433580 !important;
}
</style>